import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import { round6 } from 'utilities/math';
import { getPValue } from 'utilities';

import { ITALIC_P } from 'scenes/InferentialStatistics/Constants';

import {
  getAltHypotesisSign,
  getH0,
  getH1,
  getTableData,
  getPValue as getPValueFromStore,
  getCategoricalRowDataSet,
  getLevelsRowDataSet,
  getTStatistics
} from 'store/scenes/inferentialStatistics/selectors';

import { getTableHeadersOneSampleProportion } from 'scenes/InferentialStatistics/RightPane/Procedures/shared';

const OneSimpleProportionHypothesis = () => {
  const altHypothesisSign = useSelector(state => getAltHypotesisSign(state));
  const h0 = useSelector(state => getH0(state));
  const h1 = useSelector(state => getH1(state));
  const tableData = useSelector(state => getTableData(state));
  const pValue = useSelector(state => getPValueFromStore(state));
  const tStatistics = useSelector(state => getTStatistics(state));
  const isVariableChosen = useSelector(state => getCategoricalRowDataSet(state));
  const isLevelChosen = useSelector(state => getLevelsRowDataSet(state));

  const tableHeaders = getTableHeadersOneSampleProportion(isVariableChosen, isLevelChosen);

  return (
    <div className="content-item">
      <h3 className="mb-20">One Sample Proportion Hypothesis Test Summary</h3>
      <span className="font-900 font-16 mb-15 ml-5">{ITALIC_P}: proportion of successes in population</span>
      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>Null Hypothesis</td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">
                H<sub>0</sub>: {ITALIC_P} =
              </span>
              <span>{round6(h0)}</span>
            </td>
          </tr>
          <tr>
            <td className="pb-20">Alternative Hypothesis</td>
            <td className="pb-20">
              <span className="font-900 font-16 mb-10 mr-5">
                H<sub>1</sub>: {ITALIC_P} {altHypothesisSign}
              </span>
              <span>{round6(h1)}</span>
            </td>
          </tr>
          <tr>
            <td>Z-Statistic</td>
            <td>
              <span>{round6(tStatistics)}</span>
            </td>
          </tr>
          <tr>
            <td>P-Value</td>
            <td>
              <span>{getPValue(pValue)}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeaders} tableData={tableData} />
    </div>
  );
};

export default OneSimpleProportionHypothesis;
